import React from 'react'
import { Routes, Route, NavLink } from 'react-router-dom'
import Admin from './routes/Admin.jsx'
import Dataset from './routes/Dataset.jsx'
import './App.css'


export default function App() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Top bar */}
      <header className="border-b bg-white">
        <div className="mx-auto max-w-6xl px-4 h-14 flex items-center justify-between">
          <div className="font-semibold">CoPAN Genuine Emotions Dataset Explorer</div>
          <nav className="flex items-center gap-4 text-sm">
            <NavLink
              to="/"
              className={({ isActive }) =>
                `px-2 py-1 rounded ${isActive ? 'bg-gray-900 text-white' : 'text-gray-700 hover:bg-gray-100'}`
              }
              end
            >
              Dataset
            </NavLink>
            <NavLink
              to="/admin"
              className={({ isActive }) =>
                `px-2 py-1 rounded ${isActive ? 'bg-gray-900 text-white' : 'text-gray-700 hover:bg-gray-100'}`
              }
            >
              Admin
            </NavLink>
          </nav>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1">
        <div className="mx-auto max-w-6xl px-4 py-6">
          <Routes>
            <Route path="/" element={<Dataset />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t bg-white">
        <div className="mx-auto max-w-6xl px-4 py-4 text-xs text-gray-500">
          Refer to the researcher responsible for the dataset, or to the person who provided your key.
        </div>
      </footer>
    </div>
  )
}
